(function() { /* Start dojo-webpack-plugin extensions */
		function mix(dest, src) { // eslint-disable-line no-unused-vars
			for(var n in src) dest[n] = src[n];
			return dest;
		}

		function toUrl(name, referenceModule) {
			return loaderScope.require.toUrl(name, referenceModule);
		}

		function toAbsMid(name, referenceModule) {
			return loaderScope.require.toAbsMid(name, referenceModule);
		}

		// dojo require function.
		function req(config, dependencies, callback) {
			return contextRequire(config, dependencies, callback, 0, req);
		};

		function createContextRequire(module) { // eslint-disable-line no-unused-vars
			if (!module) return req;
			var moduleId = module.absMid;
			if (!moduleId && req.absMidsById[module.id]) {
				moduleId = req.absMidsById[module.id];
			}
			if (!moduleId) return req;
			var result = function(a1, a2, a3) {
				return contextRequire(a1, a2, a3, moduleId, req);
			};
			for (var p in req) {
				if (req.hasOwnProperty(p)) {
					result[p] = req[p];
				}
			}
			result.toUrl = function(name) {
				return toUrl(name, moduleId ? {mid: moduleId} : null);
			};
			result.toAbsMid = function(name) {
				return toAbsMid(name, moduleId ? {mid: moduleId} : null);
			};

			if (req.undef) {
				result.undef = function(mid) {
					req.undef(mid, moduleId);
				};
			}
			return result;
		}

		function registerAbsMids(absMids) { // eslint-disable-line no-unused-vars
			for (var s in absMids) {
				req.absMids[s] = absMids[s];
				if (!req.absMidsById[absMids[s]]) {
					req.absMidsById[absMids[s]] = s;
				}
			}
		}

		function resolveTernaryHasExpression(expr) { // eslint-disable-line no-unused-vars
			// Expects an expression of the form supported by dojo/has.js loader, except that module identifiers are
			// integers corresponding to webpack module ids.  Returns a module reference if evaluation of the expression
			// using the currently defined features returns a module id, or else undefined.

			var has = findModule("dojo/has", null, false);
			var id = has.normalize(expr, function(arg){return arg;});
			return id && __webpack_require__(id) || undefined;
		}

		function findModule(mid, referenceModule, noInstall, asModuleObj) {
			mid = mid.split("!").map(function(segment) {
				var isRelative = segment.charAt(0) === '.';
				if(isRelative && !referenceModule){
					return segment;
				}
				return toAbsMid(segment, referenceModule ? {mid: referenceModule} : null);
			}).join("!");
			var result;
			if (mid in req.absMids && __webpack_require__.m[req.absMids[mid]]) {
				if (noInstall) {
					var module = __webpack_module_cache__[req.absMids[mid]];
					result = module && (asModuleObj ? module : module.exports);
				} else {
					result = __webpack_require__(req.absMids[mid]);
				}
			}
			if (!result) {
				throw new Error('Module not found: ' + mid);
			}
			return result;
		}

		function dojoModuleFromWebpackModule(webpackModule) { // eslint-disable-line no-unused-vars
			if (webpackModule.absMid) return webpackModule;  // Already converted
			var result = {i:webpackModule.id};
			var id = req.absMidsById[webpackModule.id];
			if (id) {
				result.id = result.absMid = id;
			}
			Object.defineProperty(result, "exports", {
				get: function() { return webpackModule.exports;},
				set: function(value) {webpackModule.exports = value;},
				enumerable: true,
				configurable: true
			});
			return result;
		}

		function contextRequire(a1, a2, a3, referenceModule, req) { // eslint-disable-line no-shadow
			var type = ({}.toString).call(a1);
			if (type === '[object String]') {
				// a3 is passed by require calls injected into dependency arrays for dependencies specified
				// as identifiers (vs. string literals).
				var noInstall = !(a3 === false);
				var m = findModule(a1, referenceModule, noInstall);
				if (typeof m === 'object' && m.__DOJO_WEBPACK_DEFINE_PROMISE__) {
					throw new Error('Module not found: ' + a1);
				}
				return m;
			} else if (type === '[object Object]') {
				throw new Error('Require config is not supported by WebPack');
			}
			if (type === '[object Array]') {
				var modules = [], callback = a2, errors = [];
				a1.forEach(function (mid) {
					try {
						modules.push(findModule(mid, referenceModule));
					} catch (e) {
						errors.push({mid: mid, error: e});
					}
				});
				if (errors.length === 0) {
					if (callback) {
						if (true && isDefinePromise(modules)) { // eslint-disable-line no-undef
							Promise.all(wrapPromises(modules)).then(function(deps) { // eslint-disable-line no-undef
								callback.apply(this, unwrapPromises(deps)); // eslint-disable-line no-undef
							}.bind(this)).catch(function(err){console.error(err);});
						} else {
							callback.apply(this, modules);
						}
					}
				} else {
					var error = new Error("findModules");
					error.src = "dojo-webpack-plugin";
					error.info = errors;
					req.signal("error", error);
				}
				return req;
			} else {
				throw new Error('Unsupported require call');
			}
		}
		req.toUrl = toUrl;
		req.toAbsMid = toAbsMid;
		req.absMids = {};
		req.absMidsById = [];
		req.async = 1;
		function wrapPromises(deps) {
			var result = (Array.isArray(deps) ? deps : [deps]).map(function(m) {
				return (m && typeof m.then === 'function' && !m.__DOJO_WEBPACK_DEFINE_PROMISE__) ? {__DOJO_WEBPACK_PROMISE_VALUE__: m} : m;
			});
			return Array.isArray(deps) ? result : result[0];
		}

		function unwrapPromises(deps) {
			var result = (Array.isArray(deps) ? deps : [deps]).map(function(m) {
				return m && m.__DOJO_WEBPACK_PROMISE_VALUE__ || m;
			});
			return Array.isArray(deps) ? result : result[0];
		}

		function isDefinePromise(values) {
			return (Array.isArray(values) ? values : [values]).some(function(dep) {
				return typeof dep === 'object' && dep.__DOJO_WEBPACK_DEFINE_PROMISE__;
			});
		}

		function asyncDefineModule(defArray, defFactory, module, exports) { // eslint-disable-line no-unused-vars

			function setDefinePromise(promise) {
				promise.__DOJO_WEBPACK_DEFINE_PROMISE__ = true;
				return promise;
			}

			function defModule(deps) {
				module && (module.exports = exports);
				var result =  defFactory.apply(null, deps);
				if (typeof module === 'function') {
					// module is actually a callback function
					module(result);
				} else {
					if (result !== undefined) {
						module.exports = result;
					} else {
						result = module.exports;
					}
				}
				return result;
			}

			if (!isDefinePromise(defArray)) {
				return defModule(defArray);
			} else {
				return setDefinePromise(Promise.all(defArray).then(function(deps) {
					return wrapPromises(defModule(unwrapPromises(deps)));
				}));
			}
		}
	var globalObj = this||window;
	registerAbsMids({
		// "/local/buildagent/work/71550ad6d48e14da/assets/js/applicationEntryPoint.js" = 1862
		"applicationStart":6891,
		"mw-browser-utils/BrowserCheck":5061,
		"dojo/_base/window":8445,
		"dojo/_base/kernel":6270,
		"dojo/global":1317,
		"dojo/has":7741,
		"dojo/_base/config":2959,
		"dojo/_base/lang":9790,
		"dojo/sniff":1557,
		"dojo/window":923,
		"dojo/dom":2989,
		"dojo/dom-geometry":140,
		"dojo/dom-style":1718,
		"dojo/dom-construct":7697,
		"dojo/dom-attr":823,
		"dojo/dom-prop":7255,
		"dojo/_base/connect":1770,
		"dojo/on":6265,
		// "/local/buildagent/work/71550ad6d48e14da/node_modules/dojo-webpack-plugin/lib/NoModule.js" = 3121
		"dojo/aspect":1786,
		"dojo/topic":7708,
		"dojo/Evented":1452,
		"dojo/_base/event":419,
		"dojo/mouse":1678,
		"dojo/_base/sniff":416,
		"dojo/keys":6759,
		"dojo/i18n!mw-browser-utils/l10n/nls/unsupportedErrorPage":626,
		"dojo/i18n":2549,
		"dojo/_base/array":4506,
		"dojo/_base/xhr":5043,
		"dojo/io-query":3482,
		"dojo/dom-form":6396,
		"dojo/json":7633,
		"dojo/_base/Deferred":3601,
		"dojo/Deferred":9435,
		"dojo/errors/CancelError":2670,
		"dojo/errors/create":8988,
		"dojo/promise/Promise":9531,
		"dojo/when":3573,
		"dojo/_base/json":3758,
		"dojo/request/watch":955,
		"dojo/request/util":380,
		"dojo/errors/RequestError":6326,
		"dojo/errors/RequestTimeoutError":2058,
		"dojo/request/xhr":8163,
		"dojo/request/handlers":6550,
		// "/local/buildagent/work/71550ad6d48e14da/node_modules/dojo-webpack-plugin/loaders/dojo/runner.js" = 5865
		"mw-browser-utils/l10n/nls/unsupportedErrorPage":7540,
		"mw-browser-utils/detect/css":2325,
		"mw-browser-utils/detect/object":5618,
		"validation/advancedBrowserSupportCheck":5932,
		"cloudCenterWebApp":3043,
		"cloudCenterApp":9328,
		"util":7518,
		"dojo/i18n!nls/cloudCenterStringResource":7138,
		"nls/cloudCenterStringResource":9266,
		"dojo/string":5926,
		"notification/errormsg/errorMessageTranslator":8073,
		"notification/errormsg/errorCodeMessageMap":4841,
		"notification/errormsg/errorMsgOverrideData":2946,
		"constants":7899,
		"service/datatransform/ruleInfo":7367,
		"cloudCenterRouter":7347,
		"supportedProducts":7327,
		"authentication/authManager":496,
		"authentication/loginui/mwLoginPageManager":5463,
		"dao/cloudCenterDao":2116,
		"dao/abstractDao":1198,
		"dao/cloudCenterFetchDao":7427,
		"dao/mockDao":6252,
		"notification/notificationManager":1683,
		"configAppStructure":7545,
		"pages/aboutPage":2029,
		"pages/abstractPage":78,
		"service/cloudCenterDataService":8866,
		"service/platform/aws/awsDataService":6868,
		"service/platform/platformDataService":2627,
		"service/platform/aws/ec2Service":3155,
		"service/platform/aws/iamService":1095,
		"service/general/adminService":7350,
		"service/general/mathworksService":3918,
		"service/datatransform/uiElementUtil":5676,
		"service/platform/azure/azureDataService":8047,
		"service/general/oauthService":4200,
		"service/general/loggingService":5494,
		"mw-ddux/UsageLogger":729,
		"mw-ddux/DirectSender":7194,
		"mw-log/Log":8718,
		"mw-log/impl/Modes":7092,
		"mw-log/impl/Levels":1940,
		"mw-log/impl/Backlog":3910,
		"mw-log/util/LogUtils":4357,
		"mw-ddux/MatlabSender":36,
		"mw-messageservice/MessageService":2525,
		"mw-messageservice/messageserviceimpl/MessageServiceAsync":9590,
		"dojo/_base/declare":5128,
		"dojox/cometd/cometd":4800,
		"dojox/cometd/AckExtension":5895,
		"mw-messageservice/messageserviceimpl/transportEnums":1939,
		"mw-remote/iframeproxy/IframeProxyClient":5485,
		"mw-remote/iframeproxy/CheckUrlService":9581,
		"dojo/request/script":9861,
		"mw-messageservice/messageserviceimpl/MessageServiceBase":5551,
		"mw-messageservice/messageserviceimpl/MessageServiceState":166,
		"dojo/promise/all":2038,
		"mw-statemachine/StateMachine":1225,
		"mw-statemachine/statemachineimpl/State":9378,
		"mw-statemachine/statemachineimpl/EventTrigger":4913,
		"mw-statemachine/statemachineimpl/Trigger":4126,
		"mw-statemachine/statemachineimpl/MessageTrigger":1107,
		"mw-statemachine/statemachineimpl/RemoteTrigger":8311,
		"mw-remote/Remote":5372,
		"mw-remote/impl/FaultManager":8327,
		"mw-remote/impl/RequestManager":3254,
		"mw-remote/RemoteEndPointsManager":2594,
		"mw-remote/EndPointsManager":4149,
		"mw-remote/defaultMessageMapping":6490,
		"mw-remote/impl/Transaction":1362,
		"mw-utils/Utils":1843,
		"mw-utils/deprecation":781,
		"mw-remote/impl/ResponseManager":1761,
		"mw-remote/impl/AutoDetectedTransaction":8646,
		"mw-remote/impl/JsonTransaction":9173,
		"mw-remote/utils/SendMessageUtil":3167,
		"mw-remote/UploadToWorker":9944,
		"mw-html-utils/HtmlUtils":9468,
		"mw-remote/serviceRegistryLookup!":5451,
		"mw-remote/serviceRegistryLookup":3144,
		"mw-statemachine/statemachineimpl/TimeoutTrigger":1911,
		"mw-statemachine/statemachineimpl/Transition":5029,
		"mw-messageservice/messageserviceimpl/MessageServiceReqResp":8394,
		"mw-ddux/WidgetLogger":8498,
		"dijit/registry":9974,
		"dijit/main":9075,
		"service/general/cloudService":6711,
		"service/general/userService":4928,
		"service/general/sharingService":6653,
		"service/general/workflowService":2182,
		"service/cloudStatus":8349,
		"service/general/legacyParallelClusterService":9525,
		"service/general/legacyParallelCredentialService":9391,
		"service/general/legacyParallelGlobalService":9863,
		"service/datatransform/dependentOptionInfo":818,
		"service/datatransform/uiElementInfo":777,
		"service/datatransform/uiSubElementInfo":1927,
		"service/datatransform/queryDependentOptionDataArgument":7525,
		"service/datatransform/dataTransformationUtil":8621,
		"service/datatransform/credentialInfo":7512,
		"service/cachedDataService":7993,
		"service/cacheRegistry":6361,
		"wizard/ruleManager":4423,
		"releaseInfo":5439,
		"pages/managementPage":6610,
		"lit-element/lit-element.bundled":2424,
		"lit-html/lit-html-min":3505,
		"components/cloudCenterElement":9596,
		"validation/inlineElementValidation":8438,
		"components/managementCloudAccount":1008,
		"validation/inlineComponentValidation":8509,
		"components/inlinePopover":3920,
		"pages/computeResourcePage":1684,
		"computeResource/collections/collectionFactory":5813,
		"computeResource/collections/collection":3459,
		"computeResource/collections/collectionItem":9621,
		"service/cloudResource":976,
		"service/countdown":8461,
		"service/landingPageNavButtons":3350,
		"dialogs/wizardWarningDialogFactory":3978,
		"dialogs/wizardWarningDialog":4016,
		"dialogs/wizardWarningDialogAWSParallelServer":3138,
		"dialogs/wizardWarningDialogTerminateOnly":5995,
		"mw-progress-indicator/ProgressIndicator":4370,
		"mw-widget-api/defineWidget":7707,
		"mw-widget-api/WidgetBase":200,
		"mw-widget-api/facade/LitElement":4540,
		"mw-progress-indicator/view/ViewFactory":5173,
		"mw-progress-indicator/view/ViewStore":5003,
		"mw-progress-indicator/view/ViewInterface":8206,
		"mw-progress-indicator/view/SpinnerView":8905,
		"mw-widget-api/facade/svg":4633,
		"mw-progress-indicator/enums/SizeEnum":755,
		"mw-progress-indicator/enums/TypeEnum":5612,
		"mw-progress-indicator/util/ProgressIndicatorUtils":5036,
		"service/productConnect/connectionButtonGeneratorFactory":4324,
		"service/productConnect/connectionButtonGenerator":6643,
		"dialogs/connectCredentialsDialog":8497,
		"service/productConnect/matlab/matlabConnectionButtonGenerator":2245,
		"service/productConnect/cluster/clusterConnectionButtonGenerator":6642,
		"service/productConnect/onlineServer/onlineServerConnectionButtonGenerator":8706,
		"service/productConnect/parallelServer/parallelServerConnectionButtonGenerator":9535,
		"service/productConnect/productionServer/productionServerConnectionButtonGenerator":7109,
		"service/productConnect/webAppServer/webAppServerConnectionButtonGenerator":9390,
		"service/productConnect/licenseManager/licenseManagerConnectionButtonGenerator":3701,
		"service/productConnect/cfeDemo/cfeDemoConnectionButtonGenerator":6635,
		"service/productConnect/cloudNetwork/cloudNetworkConnectionButtonGenerator":932,
		"dialogs/copyToClipboardDialog":8279,
		"computeResource/computeValueFormatter":4745,
		"statusAndCountdown":8192,
		"components/editableText":3062,
		"service/specialCommands/specialCommandsManager":4107,
		"service/general/ccInternalScripts":6494,
		"computeResource/collections/collectionItemFactory":1783,
		"computeResource/collections/cluster/clusterCollectionItem":1207,
		"computeResource/collections/matlab/matlabCollectionItem":4732,
		"computeResource/collections/onlineServer/onlineServerCollectionItem":9317,
		"computeResource/collections/parallelServer/parallelServerCollectionItem":1197,
		"computeResource/collections/productionServer/productionServerCollectionItem":8402,
		"computeResource/collections/webAppServer/webAppServerCollectionItem":222,
		"computeResource/collections/licenseManager/licenseManagerCollectionItem":9029,
		"computeResource/collections/cfeDemo/cfeDemoCollectionItem":8545,
		"computeResource/collections/cloudNetwork/cloudNetworkCollectionItem":9555,
		"wizard/createMatlabWizard":4235,
		"wizard/configInfoSummary":9137,
		"wizard/createMatlabWizardStep1":1758,
		"wizard/abstractWizardStep":567,
		"wizard/inputSequenceMap":1277,
		"wizard/sequenceMapElement":5478,
		"wizard/createMatlabWizardStep2":5295,
		"wizard/uiGenerator":2091,
		"wizard/dynamic/dependentOptionManager":8787,
		"dialogs/inputPromptDialog":6704,
		"components/licenseManagerSimple":7219,
		"components/licenseManager":7914,
		"components/networkAccess":2881,
		"components/sslCertificate":9777,
		"components/createNewSSLCertificateDialog":3489,
		"components/createNewDialog":3415,
		"dialogs/createNewItemDialog":7134,
		"components/autoLogin":7961,
		"components/autologinLicenseManager":7285,
		"components/clusterStateManager":9192,
		"components/clusterStorageManager":6004,
		"components/mwClusterWorkerPicker":1690,
		"components/stackRollbackChoice":4532,
		"components/machineTypeChooserWithFinder":2085,
		"service/components/machineTypeChooserWithFinderByLocation":961,
		"service/components/abstractMachineTypeChooseWithFinder":1420,
		"service/components/machineTypeChooserWithFinderByMachineType":9568,
		"service/components/machineTypeChooserWithFinderByExistingResource":7667,
		"wizard/dynamic/dependentOptionDataBuilder":1260,
		"wizard/createMatlabWizardSummary":643,
		"dialogs/warningDialog":875,
		"computeResource/collections/cluster/clusterCollection":9890,
		"computeResource/collections/matlab/matlabCollection":8820,
		"computeResource/collections/onlineServer/onlineServerCollection":6520,
		"computeResource/collections/parallelServer/parallelServerCollection":3318,
		"computeResource/collections/productionServer/productionServerCollection":3885,
		"computeResource/collections/webAppServer/webAppServerCollection":7813,
		"computeResource/collections/licenseManager/licenseManagerCollection":1289,
		"computeResource/collections/cfeDemo/cfeDemoCollection":687,
		"computeResource/collections/cloudNetwork/cloudNetworkCollection":6623,
		"productUIGenerator":3562,
		"pages/credentialsPage":8122,
		"dialogs/selectCredentialTypeDialog":7324,
		"pages/computeResourceDetailPage":8329,
		"service/editSource":5883,
		"service/cloudAccessManager":9728,
		"service/cloudOutputsManager":8895,
		"pages/forms/editConfigForm":1905,
		"timerDropdown":3296,
		"pages/credentialsAWSImportRolePage":4767,
		"pages/credentialsAWSCreateRolePage":9345,
		"apsClient":2068
		// "/local/buildagent/temp/buildTmp/tmp-500635GakmmcnS6Wef/dojo/dojo.js" = 7595
	});

	globalObj.require = req;
		(self["webpackChunkcloudcenter2_webapp"] = self["webpackChunkcloudcenter2_webapp"] || []).registerAbsMids = registerAbsMids;

	// expose the Dojo compatibility functions as a properties of __webpack_require__
	if (__webpack_require__.dj && __webpack_require__.dj.name !== 'dojo-webpack-plugin') throw new Error("__webpack_require__.dj name collision.")
	__webpack_require__.dj = {
		name: 'dojo-webpack-plugin',
		r: req,
		c: createContextRequire,
		m: dojoModuleFromWebpackModule,
		h: resolveTernaryHasExpression,
		d: asyncDefineModule,
		w: wrapPromises,
		u: unwrapPromises
	};
	var loaderScope = Object.create(globalObj, {
	   document:{value: globalObj.document},
	});
	Object.defineProperties(loaderScope, {
	   window:{value:loaderScope},
	   global:{value:loaderScope}
	});
	loaderScope.define = loaderScope.require = undefined
	globalObj.dojoConfig = globalObj.dojoConfig || {}
	var userConfig = mix(globalObj.dojoConfig, ({'baseUrl':'.','packages':[({'name':'dojo','location':'target/debug/2P/derived/ui/dojo','lib':'.'}),({'name':'dijit','location':'target/debug/2P/derived/ui/dijit','lib':'.'}),({'name':'dojox','location':'target/debug/2P/derived/ui/dojox','lib':'.'}),({'name':'mw-log','location':'target/debug/2P/derived/ui/mw-log','lib':'.'}),({'name':'mw-utils','location':'target/debug/2P/derived/ui/mw-utils','lib':'.'}),({'name':'mw-ddux','location':'target/debug/2P/derived/ui/mw-ddux','lib':'.'}),({'name':'mw-progress-indicator','location':'target/debug/2P/derived/ui/mw-progress-indicator','lib':'.'}),({'name':'mw-widget-api','location':'target/debug/2P/derived/ui/mw-widget-api','lib':'.'}),({'name':'lit-element','location':'target/debug/2P/derived/ui/lit-element','lib':'.'}),({'name':'lit-html','location':'target/debug/2P/derived/ui/lit-html','lib':'.'}),({'name':'mw-statemachine','location':'target/debug/2P/derived/ui/mw-statemachine','lib':'.'}),({'name':'mw-peermodel','location':'target/debug/2P/derived/ui/mw-peermodel','lib':'.'}),({'name':'mw-deferred-utils','location':'target/debug/2P/derived/ui/mw-deferred-utils','lib':'.'}),({'name':'mw-remote','location':'target/debug/2P/derived/ui/mw-remote','lib':'.'}),({'name':'mw-messageservice','location':'target/debug/2P/derived/ui/mw-messageservice','lib':'.'}),({'name':'mw-html-utils','location':'target/debug/2P/derived/ui/mw-html-utils','lib':'.'}),({'name':'mw-browser-utils','location':'target/debug/2P/derived/ui/mw-browser-utils','lib':'.'}),({'name':'mldo-embedded-client','location':'target/debug/2P/derived/ui/mldo-embedded-client','lib':'.'}),({'name':'mw-utils','location':'target/debug/2P/derived/ui/mw-utils','trees':[['.','.',/(\/\.)|(~$)|(test|txt|BusyOverlay)/]],'lib':'.'})],'deps':['bootstrap'],'async':false,'has':({'config-deferredInstrumentation':false}),'supportedLocales':['en-us']}));
	var defaultConfig = ({'hasCache':({'webpack':1,'host-browser':1,'dom':1,'dojo-loader':1,'dojo-has-api':1,'dojo-dom-ready-api':1,'dojo-sniff':1,'dojo-test-sniff':1,'config-deferredInstrumentation':1,'config-tlmSiblingOfDojo':1})});
	var dojoLoader = __webpack_require__(7595);
	dojoLoader.call(loaderScope, userConfig, defaultConfig, loaderScope, loaderScope);
	Object.keys(loaderScope.require.packs).forEach(function(key) {
		var pkg = loaderScope.require.packs[key];
		if ((/(^\/)|(\:)/.test(pkg.main)	// main path is absolute
		    || pkg.main.split('/').reduce(function(acc, pathComp) {
					if (acc < 0 || pathComp === '.') return acc;
					return (pathComp === '..' ? --acc : ++acc);
				}, 0) <= 0) // main path is outside package
				&& typeof pkg.realMain === 'undefined'	// hasn't already been adjusted
		) {
			pkg.realMain = pkg.main;
			pkg.main = '';
		}
	});
	function toAbsMid(name, referenceModule) {
		var absMid = loaderScope.require.originalToAbsMid(name, referenceModule);
		if (absMid.indexOf('/') === absMid.length-1) {
			var pkgName = absMid.substring(0, absMid.length-1);
			var pkg = loaderScope.require.packs[pkgName];
			if (pkg && pkg.realMain) {
				absMid = pkgName;
			}
		}
		return absMid;
	}
	function toUrl(name, referenceModule) {
		var url = loaderScope.require.originalToUrl(name, referenceModule);
		var pkg = loaderScope.require.packs[name];
		if (pkg && pkg.realMain) {
			var parts = url.split('?');
			if (/(^\/)|(\:)/.test(pkg.realMain)) {
				// absolute URL
				parts[0] = pkg.realMain;
			} else {
				// relative URL
				parts[0] = parts[0] + '/' + pkg.realMain;
			}
			url = parts.join('?');
		}
		return url;
	}
	loaderScope.require.originalToAbsMid = loaderScope.require.toAbsMid;
	loaderScope.require.originalToUrl = loaderScope.require.toUrl;
	loaderScope.require.toAbsMid = toAbsMid;
	loaderScope.require.toUrl = toUrl;
	['baseUrl','has','rawConfig','on','signal'].forEach(function(name) {req[name] = loaderScope.require[name]})
	var absMidsWaiting = globalObj["webpackChunkcloudcenter2_webapp"].absMidsWaiting;
	if (absMidsWaiting) {
	   absMidsWaiting.forEach(registerAbsMids);
	   delete globalObj["webpackChunkcloudcenter2_webapp"].absMidsWaiting;
	}
})(); /* End dojo-webpack-plugin extensions */